import { BOTTOM_NAVIGATION_HEIGHT, Spacing } from "@bonusx-global/bx-design-system";
import { HeaderV2LayoutAction } from "../../../../../legacy/components/HeaderV2/stores/header-v2-layout-store";
import type { IHeaderV2Store } from "../../../../../legacy/components/HeaderV2/stores/header-v2-store";
import type { ILayoutStylesStore } from "../../../../../types/layout/layout-styles.type";
import type { IRouteWrapperVariant } from "../../../../../types/layout/route-wrapper-variant.interface";

const BODY_PADDING_BOTTOM_MOBILE = Spacing["2500"];
const MOBILE_PADDING_BOTTOM_WITH_BOTTOM_NAVIGATION_CLEARANCE = `calc(${BODY_PADDING_BOTTOM_MOBILE} + ${BOTTOM_NAVIGATION_HEIGHT})`;

export class ProfileRouteWrapperVariant implements IRouteWrapperVariant {
  get sidebarAvailable(): boolean {
    return true;
  }

  get headerAvailable(): boolean {
    return true;
  }

  get bottomNavigationAvailable(): boolean {
    return true;
  }

  get layoutStyles(): ILayoutStylesStore {
    return {
      contentLayoutStyles: {
        mobile: {
          paddingBottom: `${MOBILE_PADDING_BOTTOM_WITH_BOTTOM_NAVIGATION_CLEARANCE} !important`,
        },
      },
    };
  }

  get titleAvailable(): boolean {
    return false;
  }

  getVariantHeaderSettings(): IHeaderV2Store {
    return {
      layoutStore: {
        actions: [HeaderV2LayoutAction.aiAssistant, HeaderV2LayoutAction.search, HeaderV2LayoutAction.notification],
        showLogoOnMobile: true,
      },
    };
  }
}
